import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { parseBrowserType } from '../../../framework/device-utils';

@Component({
  selector: 'app-browser-icon',
  templateUrl: './browser-icon.component.html',
  styleUrls: ['./browser-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BrowserIconComponent {
  readonly browser = input<string>('');

  readonly iconSrc = computed(() => {
    const type = parseBrowserType(this.browser());
    if (!type) return null;
    const file = type === 'explorer' ? 'internet-explorer' : type;
    return `/assets/img/devices/${file}.svg`;
  });
}
